import * as wjcCore from 'wijmo/wijmo';
// angular
import {Injectable} from '@angular/core';

// libs
import {Store, Action} from '@ngrx/store';
import {Effect, Actions, ofType} from '@ngrx/effects';
import {map, switchMap} from "rxjs/internal/operators";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';

import {LotasConfig} from "../../config/lotas.config";

// module
import {DataService} from '@cosbeni/database';
import {ActionTypes, LoadUserSuccessAction, LoadUserFailureAction} from "../actions/user.action";
import {Router} from "@angular/router";
import {LoadStatesSuccessAction} from "../actions/states.action";

@Injectable()
export class UserEffects {

    @Effect() loadUser$: Observable<Action> = this.actions$.pipe(
        ofType(ActionTypes.LOAD_USER),
        switchMap(() => {
            let url = LotasConfig.SERVER_URL;
            let tokenName = LotasConfig.DATABASE + "_token";
            return this.dataService.user({}, url).map((response) => {
                let user = response;
                let states = []
                let systemAdmin = false;
                if (user.hasOwnProperty("roles") && wjcCore.isArray(user.roles)) {
                    for (let role of user.roles) {
                        if (!wjcCore.isNullOrWhiteSpace(role.state) && role.state != 'システム')
                            states.push(role.state);
                        // 全支部管理者ロール (name='管理者' / state='システム')
                        if (role.name == '管理者')
                            systemAdmin = true;
                    }
                    states = states.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t === value
                        )))
                    if (systemAdmin) {
                        // 全支部管理者は自分に割り当てられた支部に関係なく全支部を選べる。
                        // 支部の一覧は ORole の支部ロール (category='支部') を正とする。
                        this.dataService.query({
                            sql: "SELECT FROM ORole WHERE category='支部' ORDER BY state ASC",
                            fetchPlan: "*:0"
                        }, url).subscribe((data: any) => {
                            let all = [];
                            for (let role of data.results) {
                                if (!wjcCore.isNullOrWhiteSpace(role.state) && all.indexOf(role.state) < 0)
                                    all.push(role.state);
                            }
                            // 取れなかったときはロール由来の支部で動かす (選択肢が空になるのを避ける)
                            this.store.dispatch(new LoadStatesSuccessAction(all.length > 0 ? all : states));
                        }, () => {
                            this.store.dispatch(new LoadStatesSuccessAction(states));
                        });
                    } else {
                        this.store.dispatch(new LoadStatesSuccessAction(states));
                    }
                }
                return new LoadUserSuccessAction(user);
            }).catch(() => {
                    this.router.navigate(["login"], {})
                    return Observable.of(new LoadUserFailureAction())
                }
            );
        })
    )

    constructor(private store: Store<any>,
                private actions$: Actions,
                private dataService: DataService,
                private router: Router) {
    }
}
